import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Container = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  touch-action: none;
  overflow: hidden;

  width: 100vw;
  height: 100vh;

  z-index: 6;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};

  svg {
    width: 10vw;
    height: auto;
    overflow: visible;
    stroke-linejoin: round;
    stroke-linecap: round;

    g {
      path {
        stroke: ${(props) => props.theme.text};
      }
    }
  }

  @media (max-width: 48em) {
    svg {
      width: 20vw;
    }
  }
`;

const Text = styled(motion.span)`
  font-size: ${(props) => props.theme.fontxl};
  color: ${(props) => props.theme.text};
  padding-top: 10.5rem;

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontlg};
  }
`;

const textVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,

    transition: {
      duration: 4,
      yoyo: Infinity, 
      ease: "easeInOut",
    },
  },
};

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,

    transition: {
      duration: 8,
      ease: "easeInOut",
    },
  },
};

const Loader = () => {
  return (
    <Container
      initial={{
        y: 0,
        opacity: 1,
      }}
      exit={{
        y: "100%",
        opacity: 0,
      }}
      transition={{
        duration:3,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 88 88"
        height="144px"
        viewBox="135 0 150 200"
        width="144px"
        fill="none"
      >
        <g></g>
        <g>
          <motion.path
            variants={pathVariants}
            initial="hidden"
            animate="visible"
           d="M145.5 186.5C162 171 151.5 152.5 163.5 145C163.5 150.5 159.5 155 164 161.5C170.074 173.408 171.196 179.427 157 185.5C153.521 186.549 152.154 187.609 146 186.5M224.5 227C224.5 221 221.5 216.5 213.5 216.5C205.5 216.5 202.5 219 202 227C201.5 235 204.952 238.35 213.5 239C220.564 238.639 223.455 236.497 224.254 231M224.5 227C224.5 228.497 224.425 229.825 224.254 231M224.5 227L224.254 231M21 40.5C53.5905 17.8062 75.7932 13.5419 121 18L160.5 135.5L150.5 144.5C135.332 146.516 131.183 150.695 130 162.5C128.45 202.686 133.316 223.097 142 259.5C145.644 270.009 132.064 281.924 107 303.5C106.3 317.15 107.844 324.822 110 338.5C106.495 325.909 104.142 319.348 98.5 309.5C55.5 328.5 29.5231 337.097 5.99997 318.5C12.165 286.885 13.5264 269.435 14.5 238.5C14.5 238.5 11 236.5 9.5 233.5C8 230.5 11.1393 223.066 17 211.5C3.00814 207.172 -2.73557 203.646 2.99998 189H5.99997C1.32765 195.792 1.49692 198.925 5.99997 203.5L39 200C36.9112 204.433 36.432 206.373 36 209.5C48.3097 209.993 52.988 220.32 60.5 242.5H63L66.5 229L69.5 231C74.4955 211.862 109.5 202.5 109.5 177C109.5 151.5 106 131 106 131C95 119 83.7702 115.496 77 102.5C74.2519 94.6339 80.493 86.5382 95 70.5C57.0674 70.2391 44.519 74.8739 31 88C31.8196 77.1519 30.8798 72.6256 27 67C20.7952 56.0788 19.2282 50.2391 21 40.5ZM25 138.5C41.111 127.04 49.691 127.803 64.5 137C50.4025 138.088 42.5643 138.995 29 142.5L25 138.5ZM18.5 134C17.5 141 25 145.5 22.5 152C18 145.5 14 140.5 16.5 134.5L18.5 134ZM37 145.5L45.5 156.5L58.5 148.5L37 145.5ZM178.5 189.5C172.492 196.889 168.88 200.287 162 205L164 206L180 194.5L178.5 189.5ZM79.5 23.5C67.6451 25.2652 63.2467 27.9983 57.5 34.5V37H59.5V46C64.8238 35.4124 69.1889 31.0145 79.5 26V23.5ZM133.5 35.5L211.5 194L296.5 26.5L239 194.5C230.252 217.072 229.155 230.116 239 252.5L297.5 353C318.909 355.277 328.914 359.758 338.5 381C342.44 398.78 340.822 408.601 322 425.5C309 435 286.582 435.3 269 414C262 406 259.5 384 267.5 372.5C272.484 365.279 276.413 362.138 284 357C284 357 257 306.5 241.5 281C226 255.5 203.5 254 181.5 279.5L140 354.5C152.103 364.407 155.924 371.684 157 388C153.716 407.824 148.309 416.342 129 424.5C107.5 427.5 96.8191 423.599 83.5 405.5C76.1867 389.097 76.0585 379.559 88 361.5C99.4593 349.283 108.026 346.183 127.5 348L184.5 252.5C195.441 229.001 194.707 216.359 184.5 194.5L133.5 43L132 35.5H133.5ZM302.5 27.5L300 34.5C308.331 29.8183 312.205 26.3112 315 15.5C310.813 20.7859 308.162 23.4871 302.5 27.5ZM287.5 69.5L280.5 90C320.019 71.4162 332.258 58.6554 327 29.5C323.01 52.9658 315.018 62.1746 287.5 69.5ZM271 118L257 158L287.5 139C261.446 174.274 250.078 196.356 240 243L301.5 350C312.825 350.779 319.435 352.864 332 361.5C389.166 358.128 410.96 343.951 435.5 301.5C403.06 335.684 380.803 344.786 332 338.5C307.904 333.664 295.311 328.024 278 301.5C268.44 281.282 265.465 268.943 269.5 243C275.093 212.374 283.297 191.295 317 139C351.257 82.2834 353.952 57.2964 337.5 21.5C346.137 72.9718 331.15 93.9313 271 118ZM296.5 215C291 292 326 333.5 402.5 307C373.73 329.188 353.642 335.314 313 313.5C289.436 290.722 282.961 273.001 291 227L296.5 215ZM341.5 0.5C361.512 32.3148 369.124 50.8187 365.5 87C360.443 116.647 345 143.5 324.5 176.5C304 209.5 307.5 244.5 329 283C329.454 235.32 334.132 210.808 419 205.5C425.565 204.531 427.207 200.59 422 180C423.347 173.271 423.989 169.044 427 169C428.265 164.978 428.08 163.081 427 160C423.724 159.681 421.879 159.485 417.5 157L416.5 154C422.356 151.067 424.72 149.271 425.5 145.5C424.834 141.29 423.847 140.394 422 139L419 136V129.5C421.683 124.936 423.366 122.646 427 119.5C430.562 114.926 430.895 112.674 427 109.5C415.077 102.286 408.651 97.8991 398 89V85.5L403.5 79.5L402 75.5L400 71C397.736 77.7298 396.26 79.7496 393 78C385.192 41.615 378.1 25.0404 355.5 9.5L341.5 0.5ZM117 354.5C134.728 354.802 146.039 361.334 150 388C148.34 402.996 145.115 410.184 129 417.5C112.775 422.173 104.36 420.185 91 405.5C85.4584 396.338 83.2159 387.788 88 372.5C93.2072 362.257 98.1534 357.946 110 354.5H117ZM301.5 359C317.244 362.348 325.273 365.317 332 381C336.802 397.471 334.092 405.572 322 418.5C305.027 428.302 293.87 428.105 277 414C269.262 403.867 265.271 392.33 275.5 372.5C281.574 365.27 286.129 362.111 297.5 359H301.5Z"
          />
        </g>
      </svg>
      <Text variants={textVariants} initial="hidden" animate="visible">
      Elan Studio
      </Text>
    </Container>
  );
};

export default Loader;
